import { Ncm } from '@/core/domain/operational/Ncm/Ncm.types';
import { InvoiceSettingsData } from '../../settings/Settings.types';
import {
  IcmsBaseCalculationDeterminationMode,
  InvoiceIcmsCstCsosn,
  IpiCst,
  PisCofinsCst,
} from './InvoiceNoteItems.types';
import { InvoiceType } from '../../invoices/invoices.enums';

const calculationDeterminationMode: Record<
  number,
  IcmsBaseCalculationDeterminationMode
> = {
  0: IcmsBaseCalculationDeterminationMode.MARGIN_VALUE_ADDED,
  1: IcmsBaseCalculationDeterminationMode.TABLE_PRICE_MAX,
  2: IcmsBaseCalculationDeterminationMode.LIST_PRICE_MAX,
  3: IcmsBaseCalculationDeterminationMode.OPERATION_VALUE,
};

export function formSetFieldsValueTributes(
  ncm: Ncm,
  invoiceSettingData: InvoiceSettingsData,
  invoiceType: InvoiceType,
  ncmIcmsCst: InvoiceIcmsCstCsosn,
  changeTaxRegime = false,
  valueUnitary?: number,
  quantity?: number,
) {
  let invoiceSetting;

  if (invoiceType === InvoiceType.NFE)
    invoiceSetting = invoiceSettingData.configNfe;

  if (invoiceType === InvoiceType.NFC)
    invoiceSetting = invoiceSettingData.configNfc;

  return {
    ...(ncm.cest ? { cest: ncm.cest } : {}),
    //geral
    approximateTaxValue:
      typeof valueUnitary === 'number' &&
      typeof quantity === 'number' &&
      typeof ncm?.taxesPercentage === 'number'
        ? ((valueUnitary * quantity) / 100) * ncm.taxesPercentage
        : undefined,
    itemTaxes: {
      //icms
      ...(changeTaxRegime
        ? { taxRegime: invoiceSetting?.taxRegimeDefault }
        : {}),
      icmsBaseCalculationDeterminationMode:
        calculationDeterminationMode[Number(ncm.modalityDeterminationBcIcms)] ||
        (invoiceSetting?.icmsBaseCalculationDeterminationModeDefault as IcmsBaseCalculationDeterminationMode),
      icmsCst: ncmIcmsCst || invoiceSetting?.icmsCstDefault,
      icmsOrigin: invoiceSetting?.icmsOriginDefault,
      icmsAliquot: ncm.aliquotIcms || invoiceSetting?.icmsAliquotDefault,
      icmsBaseCalculationReductionPercentage: ncm.reductionIcms,
      //ipi
      ipiAliquot: ncm.aliquotIpi || invoiceSetting?.ipiAliquotDefault,
      ipiCst: (ncm.cstIpi || invoiceSetting?.ipiCstDefault) as IpiCst,
      ipiLegalClassificationCode:
        invoiceSetting?.ipiLegalClassificationCodeDefault,
      //pis
      pisAliquot: ncm.aliquotPis || invoiceSetting?.pisAliquotDefault,
      pisCst: (ncm.cstPis || invoiceSetting?.pisCstDefault) as PisCofinsCst,
      //cofins
      cofinsAliquot: ncm.aliquotCofins || invoiceSetting?.cofinsAliquotDefault,
      cofinsCst: ncm.cstCofins || invoiceSetting?.cofinsCstDefault,
    },
  };
}
